/**
 * @generated SignedSource<<316a004180f3d949fb9cf8ce0ffb97dc>>
 * @relayHash 044e27832145774d49d0d615ef03b9d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 720b4f7aa278046d69b3c13196f405b79dee8a76ea1d4ee85d9345f0c1ff2dce

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type TownsquareProjectsAddJiraWorkItemLinkInput = {
  projectId: string;
  replace?: boolean | null | undefined;
  replaceChildWorkItemLinks?: boolean | null | undefined;
  replaceCurrentWorkItemLink?: boolean | null | undefined;
  workItemId: string;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$variables = {
  input: TownsquareProjectsAddJiraWorkItemLinkInput;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$data = {
  readonly projects_addJiraWorkItemLink: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: string;
        readonly canReplace?: boolean | null | undefined;
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation = {
  response: atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$data;
  variables: atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canReplace"
    }
  ],
  "type": "TownsquareProjectsChildWorkItemsAlreadyLinkedMutationErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
        "kind": "LinkedField",
        "name": "projects_addJiraWorkItemLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
        "kind": "LinkedField",
        "name": "projects_addJiraWorkItemLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "720b4f7aa278046d69b3c13196f405b79dee8a76ea1d4ee85d9345f0c1ff2dce",
    "metadata": {},
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c423f19e22ae55b49c7da9df767fe9b1";

export default node;
